module.exports = __webpack_public_path__ + "media/images/keyVisual_pc_en-bc81d9a9de955e20b22f6633cd2b9113.jpg";